import React, { useContext, memo } from 'react';
import { AppContext } from 'src/components/app-context';
import { AdContext } from '../context';
import { getAdService } from '.';
import { getAdContextCookie } from '../helpers/cookie';

const AdServiceContext = React.createContext(null);
AdServiceContext.displayName = 'AdServiceContext';

const AdServiceContextProvider: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<IAdServiceContext>>
> = props => {
  const { market } = useContext(AppContext);
  const adContext = useContext(AdContext);
  const serviceName = getAdContextCookie().service || market.ads.service;
  const service = getAdService(serviceName);
  const config = market.ads[serviceName] || {};

  return adContext.active ? (
    <service.provider
      config={config}
      adContext={adContext}
      baseProvider={AdServiceContext.Provider}
    >
      {props.children}
    </service.provider>
  ) : (
    props.children
  );
};

interface IAdServiceContext {
  children: JSX.Element | React.ReactElement;
}

export default {
  Provider: memo(AdServiceContextProvider),
  Consumer: AdServiceContext.Consumer,
};
